import React from 'react';

function DataPreview({ data, title, className = '', hideTitle = false }) {
	if (!data || data.length === 0) return null;

	return (
		<div className={className}>
			{!hideTitle && (
				<h3 className='text-xl font-semibold text-gray-800 mb-3'>
					{title} Preview ({data.length} records)
				</h3>
			)}
			<div className='overflow-x-auto shadow-md rounded-lg'>
				<table className='min-w-full divide-y divide-gray-200'>
					<thead className='bg-gray-50'>
						<tr>
							{Object.keys(data[0]).map((key) => (
								<th key={key} scope='col' className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
									{key}
								</th>
							))}
						</tr>
					</thead>
					<tbody className='bg-white divide-y divide-gray-200'>
						{data.slice(0, 5).map((item, index) => (
							<tr key={index} className='hover:bg-gray-50'>
								{Object.values(item).map((value, i) => (
									<td key={i} className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
										{value !== null && value !== undefined ? String(value) : ''}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
				{data.length > 5 && <div className='px-6 py-3 bg-gray-50 text-sm text-gray-500 border-t border-gray-200'>...and {data.length - 5} more records</div>}
			</div>
		</div>
	);
}

export default DataPreview;
